import { BooleanParam, useQueryParam, withDefault } from "use-query-params";

export const useShowTableSelectColumn = () => {
  return useQueryParam(
    "pt-show-table-checkboxes",
    withDefault(BooleanParam, true),
    {
      updateType: "pushIn",
    },
  );
};
